module.exports = __webpack_public_path__ + "img/xcxlogin.189939d4.png";